// extracted by mini-css-extract-plugin
module.exports = {"loading":"AccountPopup_loading__o8CXK","link":"AccountPopup_link__nU_Xv","account":"AccountPopup_account__pKQct","footer":"AccountPopup_footer__yzLIa"};